import { render, staticRenderFns } from "./personnelDatabase.vue?vue&type=template&id=010519eb&scoped=true"
import script from "./personnelDatabase.vue?vue&type=script&lang=js"
export * from "./personnelDatabase.vue?vue&type=script&lang=js"
import style0 from "./personnelDatabase.vue?vue&type=style&index=0&id=010519eb&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010519eb",
  null
  
)

export default component.exports